// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__BrSGe","logo":"LinkedLogo_logo__-ZpeB","logoImage":"LinkedLogo_logoImage__Qa5Na"};